module.exports = __webpack_public_path__ + "static/media/Placaj-Ceramic-Klinker-250-X-65-X-10---Toscana-(04).9407db50.jpg";